import React from 'react';
import { Label } from 'semantic-ui-react';
import { capitalize } from '../../utils/utils';

const filterNonApplicableOptions = (opts, cats) => {
  // strip out any non applicable filters from the url that are not listed in filter categories.
  return opts.filter((opt) => cats.find((c) => c.name === opt.name));
};

export const ChipDrawer = ({
  page,
  selectedFilters,
  filterCategories,
  handleDeselectChip
}) => {
  selectedFilters = filterNonApplicableOptions(
    selectedFilters,
    filterCategories
  );
  return (
    <div className="filter-chips">
      {!!selectedFilters.length && (
        <div>
          {selectedFilters.map((sFilter, i) =>
            sFilter.values.length > 0 ? (
              <Label
                key={i}
                circular={true}
                style={{
                  backgroundColor: '#715091',
                  borderColor: '#715091',
                  color: '#fff'
                }}>
                {filterCategories.find((c) => c.name === sFilter.name).title}:{' '}
                {sFilter.values.length > 3
                  ? `(${sFilter.values.length})`
                  : sFilter.values.map(capitalize).join(', ')}{' '}
                <button
                  style={{
                    outline: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    margin: 0,
                    padding: '0 0 0 5px',
                    fontWeight: 800,
                    fontSize: '16px'
                  }}
                  onClick={() =>
                    handleDeselectChip({ name: sFilter.name, page })
                  }>
                  &times;
                </button>
              </Label>
            ) : null
          )}
        </div>
      )}
    </div>
  );
};

export default ChipDrawer;
